// assets
import { DashboardOutlined } from '@ant-design/icons';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';

// icons
const icons = {
  DashboardOutlined,
  CorporateFareIcon,
  TaskAltOutlinedIcon,
  GroupOutlinedIcon,
  LanguageOutlinedIcon,
  AssessmentOutlinedIcon,
  FactCheckOutlinedIcon,
  ConfirmationNumberOutlinedIcon
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  // title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_MEMBER', 'ROLE_ORG_ADMIN', 'ROLE_PROJECT_MANAGER'],
      breadcrumbs: false
    },
    {
      id: 'Tickets',
      title: 'TMS',
      type: 'item',
      url: '/tickets',
      icon: icons.ConfirmationNumberOutlinedIcon,
      allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_MEMBER', 'ROLE_ORG_ADMIN', 'ROLE_PROJECT_MANAGER'],
      breadcrumbs: false
    },
    {
      id: 'Projects',
      title: 'Projects',
      type: 'item',
      url: '/projects',
      icon: icons.TaskAltOutlinedIcon,
      allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_MEMBER', 'ROLE_ORG_ADMIN', 'ROLE_PROJECT_MANAGER'],
      breadcrumbs: false
    },
    // {
    //   id: 'test-management',
    //   title: 'Test Management',
    //   type: 'item',
    //   url: '/test-management',
    //   icon: icons.FactCheckOutlinedIcon,
    //   allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_MEMBER', 'ROLE_ORG_ADMIN', 'ROLE_PROJECT_MANAGER'],
    //   breadcrumbs: false
    // },
    {
      id: 'Users',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: icons.GroupOutlinedIcon,
      allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ORG_ADMIN'],
      breadcrumbs: false
    },
    // {
    //   id: 'components',
    //   title: 'Components',
    //   type: 'item',
    //   url: '/jira',
    //   icon: icons.GroupOutlinedIcon,
    //   allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ORG_ADMIN', 'ROLE_PROJECT_MANAGER'],
    //   breadcrumbs: false
    // },
    {
      id: 'Organizations',
      title: 'Organizations',
      type: 'item',
      url: '/organizations',
      icon: icons.CorporateFareIcon,
      allowedRoles: ['ROLE_SUPER_ADMIN'],
      breadcrumbs: false
    },
    // {
    //   id: 'Environments',
    //   title: 'Environments',
    //   type: 'item',
    //   url: '/environments',
    //   icon: icons.LanguageOutlinedIcon,
    //   allowedRoles: ['ROLE_MEMBER'],
    //   breadcrumbs: false
    // },
    {
      id: 'configuration',
      title: 'configuration',
      type: 'item',
      url: '/configuration',
      icon: icons.GroupOutlinedIcon,
      allowedRoles: ['ROLE_SUPER_ADMIN'],
      breadcrumbs: false
    },
    {
      id: 'Reports',
      title: 'Reports',
      type: 'item',
      url: '/reports',
      icon: icons.AssessmentOutlinedIcon,
      allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_MEMBER', 'ROLE_ORG_ADMIN', 'ROLE_PROJECT_MANAGER'],
      breadcrumbs: false
    }
  ]
};

export default dashboard;
